<script setup lang="ts">
import HisRadiologyWorkspace from "@/components/his/HisRadiologyWorkspace.vue";

definePage({
  meta: {
    layout: "blank",
  },
});
</script>

<template>
  <HisRadiologyWorkspace />
</template>
